export const cityList = ['Vancouver', 'Washington', 'Barcelona', 'Manchester', 'Wien', 'Brussels']
export const itemList = []
